import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import HeroPanel from './HeroPanel';
import ReviewPanel from './ReviewPanel';
import ProductsPanel from './ProductsPanel';
import PodcastPanel from './PodcastPanel';
import CommunityImagePanel from './CommunityImagePanel';
import CommunityPanel from './CommunityPanel';
import FooterPanel from './FooterPanel';
import MenuPanel from "./MenuPanel";

const useStyles = theme => ({
    branding: {
        display: 'flex',
        flexWrap: 'wrap',
    },
});

class WelcomePage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  componentDidMount() {
  }

  componentWillUnmount() {
  }

  render() {
      const { classes } = this.props;

      return (
          <div className={classes.branding}>
              <MenuPanel page={'welcome'}/>
              <HeroPanel/>
              <ReviewPanel/>
              <ProductsPanel/>
              <PodcastPanel/>
              <CommunityImagePanel/>
              <CommunityPanel/>
              <FooterPanel/>
          </div>
      );
  }
}

export default withStyles(useStyles)(WelcomePage)
